<template>
    <div
        class="flex flex-row flex-wrap p-3 border-2 border-background-3 hover:shadow-[0_8px_12px_0px_rgba(0,0,0,0.05)]"
    >
        <div class="xxs:min-w-[150px] xxs:min-h-[80px] lg:min-h-[42px] lg:min-w-20 bg-interactive-7/20 flex items-center justify-center rounded" v-if="!hasThumbnail">
            <router-link
                :to="`/resources/view/${resource.uid}`"
                v-if="isPageResource"
            >
                <AnchorIcon
                    class="w-4"
                    :color="color" />
            </router-link>

            <a :href="formattedUrl"
               target="_blank"
               v-if="!isPageResource"
            >
                <AnchorIcon
                    class="w-4"
                    :color="color" />
            </a>

        </div>

        <router-link
            :to="`/resources/view/${resource.uid}`"
            class="w-15 lg:w-20 max-w-[150px]"
            v-if="isPageResource && hasThumbnail"
        >
            <Image :src="props.resource.resourceable.thumbnail" type="thumbnail" roundness="rounded" />
        </router-link>

        <a :href="formattedUrl"
            target="_blank"
            class="w-15 lg:w-20 max-w-[150px]"
            v-if="!isPageResource && hasThumbnail"
        >
            <Image :src="props.resource.resourceable.thumbnail" type="thumbnail" roundness="rounded" />
        </a>

        <div class="flex flex-col ml-2 flex-1">
            <router-link
                :to="`/resources/view/${resource.uid}`"
                v-if="isPageResource"
            >
                <p class="text-body-6 font-medium text-default-1 hover:text-primary-1 flex-1 overflow-hidden overflow-ellipsis max-h-[42px] multi-line-ellipsis clamp-2-line" :class="'-mt-1' && resource.resourceable_type === 'page'">
                    {{ resource.resourceable.title }}
                </p>
            </router-link>
            <a :href="formattedUrl" target="_blank" v-else>
                <p class="text-body-6 font-medium text-default-1 hover:text-primary-1 flex-1 overflow-hidden overflow-ellipsis max-h-[42px] multi-line-ellipsis clamp-2-line" :class="'-mt-1' && resource.resourceable_type === 'page'">
                    {{ resource.resourceable.title }}
                </p>
            </a>

            <div class="w-full justify-between flex mt-1">
                <p class="text-body-6 font-normal text-default-2"> {{ formattedDate }} </p>
                <Favorite
                    :is-liked="resource.isLiked"
                    :resource-uid="resource.uid"
                    @toggle-like="toggleLike"
                />
            </div>
        </div>
    </div>
</template>
<script setup>
import Favorite from "@/components/custom/resources/Favorite.vue";
import {computed} from "vue";
import {useFormatDate} from "@/composables/useFormatDate";
import Image from "@/components/custom/Image.vue";
import AnchorIcon from "@/components/icons/small/Anchor.vue";

const props = defineProps({
    color: {
        type: String,
        required: true
    },
    resource: {
        type: Object
    },
    index: {
        type: Number
    }
})

const formattedDate = computed(() => {
    if(!props.resource.resourceable) {
        return '';
    }

    return useFormatDate(props.resource.resourceable.created_at);
});

const emit = defineEmits(['toggleLike'])

function toggleLike() {
    emit('toggleLike', props.index)
}

const hasThumbnail = computed(() => {
    if(!props.resource || !Object.hasOwn(props.resource.resourceable, 'thumbnail') || !props.resource.resourceable.thumbnail) {
        return false;
    }

    return props.resource.resourceable.thumbnail.length > 0;
})

const isPageResource = computed(() => {
    return props.resource.resourceable_type === 'page';
})

const formattedUrl = computed(() => {
    if(props.resource.resourceable.url.includes('http://') || props.resource.resourceable.url.includes('https://')) {
        return props.resource.resourceable.url;
    }
    return `https://${props.resource.resourceable.url}`;
})

const backgroundImageStyle = computed(() => {
    return {
        backgroundImage: `url(${props.resource.resourceable.thumbnail})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center'
    }
});
</script>